// Hand-rolled Redux slice for offline download state.
// (Project does not use @reduxjs/toolkit; this file bundles action types,
//  action creators, and the reducer in one module.)

const SET_DOWNLOAD_STATE = 'offline/setDownloadState';
const REMOVE_DOWNLOAD = 'offline/removeDownload';
const HYDRATE_OFFLINE_DOWNLOADS = 'offline/hydrateOfflineDownloads';
const SET_DRAFT_SYNC = 'offline/setDraftSync';

const initialState = {
  // ticketId → { state: 'idle'|'downloading'|'ready'|'failed', progress: 0..1, error?: string }
  downloads: {},
  // Auto-sync sweep progress for offline drafts (native-only). active=true while a sweep is in flight.
  draftSync: { active: false, total: 0, done: 0, failed: 0 },
};

export const setDownloadState = (payload) => ({ type: SET_DOWNLOAD_STATE, payload });
export const removeDownload = (ticketId) => ({ type: REMOVE_DOWNLOAD, payload: ticketId });
// payload = the authoritative list of downloaded tickets from SQLite (storage.listOfflineTickets).
export const hydrateOfflineDownloads = (tickets) => ({ type: HYDRATE_OFFLINE_DOWNLOADS, payload: tickets });
// Merge a partial draft-sync progress update ({ active?, total?, done?, failed? }).
export const setDraftSync = (payload) => ({ type: SET_DRAFT_SYNC, payload });

export default function offlineReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DOWNLOAD_STATE: {
      const { ticketId, ...rest } = action.payload;
      return {
        ...state,
        downloads: {
          ...state.downloads,
          [ticketId]: { ...(state.downloads[ticketId] || {}), ...rest },
        },
      };
    }
    case REMOVE_DOWNLOAD: {
      const next = { ...state.downloads };
      delete next[action.payload];
      return { ...state, downloads: next };
    }
    case HYDRATE_OFFLINE_DOWNLOADS: {
      // REBUILD from the authoritative SQLite list (replace, not merge): only tickets still present in
      // SQLite are `ready`. This is what keeps the indicator in sync with the source of truth — a removed
      // ticket (no longer in SQLite) can't linger as a stale `ready`, and a stale `locked`/`failed` from a
      // past failed attempt is dropped. An in-flight `downloading` entry is preserved so an active
      // download isn't visually interrupted. Only dispatched on a successful list call, so a transient
      // bridge failure never wipes a downloaded ✅.
      const downloads = {};
      for (const [id, d] of Object.entries(state.downloads || {})) {
        if (d?.state === 'downloading') downloads[id] = d;
      }
      for (const t of action.payload || []) {
        const id = t._id || t.id;
        if (id) downloads[id] = { state: 'ready', progress: 1 };
      }
      return { ...state, downloads };
    }
    case SET_DRAFT_SYNC: {
      return { ...state, draftSync: { ...state.draftSync, ...action.payload } };
    }
    default:
      return state;
  }
}
